"use strict";

var MAX_NOTIFICATIONS = 50;

CompanyNotificationsCtrl.$inject = [
  '$rootScope',
  '$scope',
  '$stateParams',
  'CompanyNotificationsService'];
function CompanyNotificationsCtrl(
  $rootScope,
  $scope,
  $stateParams,
  CompanyNotificationsService) {
  
  setTimeout(function(){
    if($rootScope.notificationsUnread > 0){
      CompanyNotificationsService.update({companyId: $stateParams.companyId}, {}, function(){
        $rootScope.notificationsUnread = 0;
        angular.forEach($rootScope.notifications, function(notification){
          notification.viewed = true;
        });
      });
    }
  }, 5000);

  $rootScope.notificationLimit = MAX_NOTIFICATIONS;
}

angular.module("dokiv")
  .controller("CompanyNotificationsCtrl", CompanyNotificationsCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyNotificationsCtrl.js
// module id = 325
// module chunks = 0